import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function BillingSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    // Mark billing setup as complete
    const completeBillingSetup = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          await axios.post(
            `${process.env.REACT_APP_API}/complete-billing-setup`,
            {},
            { headers: { Authorization: `Bearer ${token}` } }
          );
        } catch (error) {
          console.error('Error completing billing setup:', error);
          // Continue anyway - don't block user from dashboard
        }
      }

      sessionStorage.setItem('postBillingOnboarding', 'true');
    };

    completeBillingSetup();

    // Redirect to dashboard after 3 seconds
    const timer = setTimeout(() => {
      navigate('/refer/dashboard');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ padding: '4rem 2rem', textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
      <div
        style={{
          fontSize: '4rem',
          color: '#22c55e',
          marginBottom: '1rem',
        }}
      >
        ✓
      </div>

      <h1 style={{ color: '#22c55e', marginBottom: '1rem' }}>Payment Successful!</h1>

      <p style={{ fontSize: '1.125rem', color: '#6b7280', marginBottom: '2rem' }}>
        Thank you for subscribing to PlexysRefer Pro. Your subscription is now active.
      </p>

      <div
        style={{
          padding: '1.5rem',
          backgroundColor: '#f0fdf4',
          border: '2px solid #22c55e',
          borderRadius: '8px',
          marginBottom: '2rem',
        }}
      >
        <p style={{ margin: 0, fontWeight: '500' }}>
          You now have full access to all features:
        </p>
        <ul style={{ textAlign: 'left', margin: '1rem auto', maxWidth: '400px' }}>
          <li>Unlimited patient referrals</li>
          <li>AI-powered analytics</li>
          <li>Market intelligence</li>
          <li>Provider quality scoring</li>
        </ul>
      </div>

      <p style={{ color: '#9ca3af', fontSize: '0.875rem' }}>
        Redirecting to dashboard in 3 seconds...
      </p>

      <button
        onClick={() => navigate('/refer/dashboard')}
        style={{
          marginTop: '1rem',
          padding: '0.75rem 2rem',
          backgroundColor: '#3b82f6',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontSize: '1rem',
          fontWeight: '600',
          cursor: 'pointer',
        }}
      >
        Go to Dashboard Now
      </button>
    </div>
  );
}
